var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMynauiSparkles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3083 17.5C13.2442 13.6258 14.38 12.4175 17.5 11.3633C14.2217 10.2567 13.2 8.91333 12.3083 5.2275C11.3717 9.10167 10.235 10.3092 7.115 11.3633C10.39 12.4692 11.4175 13.8217 12.3075 17.5M5.38417 9.31833C5.81083 7.30167 6.63583 6.39167 8.26833 5.90917C6.63583 5.42667 5.81083 4.51667 5.385 2.5C4.97667 4.42917 4.20583 5.40417 2.5 5.90833C4.1325 6.39167 4.9575 7.30167 5.38417 9.31833Z",
    stroke: "#FCDF39",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMynauiSparkles);
export default __webpack_public_path__ + "static/media/mynaui_sparkles.7e7a1c35b87238b312d858c948487cd0.svg";
export { ForwardRef as ReactComponent };